import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { OrgnaziationContext } from '../Home';

export default function useOrgIdentifer(){
  const {organization_name} = useParams();
  const { orgName } = useContext(OrgnaziationContext)
  return organization_name ? organization_name : orgName
}
